import React, { Component } from 'react';
import { List, OrderedMap } from 'immutable';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';

import EditableTextField from './EditableTextField';
import css from './forms.css';

// Material UI Library
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import ContentAdd from 'material-ui/svg-icons/content/add';
import { Card, CardActions } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';

class EditableCollection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      items: (this.props.collection ? this.props.collection.toOrderedMap() : OrderedMap()),
    };
  }

  componentWillReceiveProps(newProps) {
    if (newProps.collection !== this.props.collection) {
      this.setState({
        items: newProps.collection.toOrderedMap(),
      });
    }
  }

  handleUpdateForm = (key, name, id, value) => {
    const updatedProperty = id ? { id: id, [name]: value } : { [name]: value };
    this.props.saveValue([updatedProperty]);
  };

  addAnotherItem = () => {
    this.setState({
      items: this.state.items.merge({
        [this.state.items.size]: {},
      }),
    });
  };

  removeItem = (key) => {
    // Update db if existing item
    if (this.state.items.get(key).get('id')) {
      this.props.saveValue([{ id: this.state.items.get(key).get('id'), _destroy: true }]);
    } else {
      const updatedItems = this.state.items.delete(key);
      this.setState({ items: updatedItems });
    }
  };

  render() {
    if (this.props.multiLine) {
      return (
        <div>
          <h3 className={css.actionTitle}>
            {this.props.title}
            <FlatButton primary={true} onTouchTap={this.addAnotherItem}>
              Add
            </FlatButton>
          </h3>
          {this.state.items && this.state.items.mapEntries(([key, value]) =>
            [
              key,
              <Card style={{ padding: '15px', marginBottom: '10px' }} key={key}>
                {this.props.children.map((child, index) =>
                  React.cloneElement(child, {
                    key: `${child.props.name}-${index}`,
                    value: value.get(child.props.name),
                    saveValue: this.handleUpdateForm.bind(this, key, child.props.name, value.get('id')),
                  })
                )}
                <CardActions
                  key={`${this.props.name}-actions-${key}`}
                  style={{ textAlign: 'right' }}
                >
                  <FlatButton
                    onTouchTap={this.removeItem.bind(this, key)}
                    key={`${this.props.name}-contentadd`}
                    label="Remove"
                  />
                </CardActions>
              </Card>,
            ]
          ).toList()}
        </div>
      );
    }

    return (
      <Card>
        {this.state.items && this.state.items.mapEntries(([key, value]) =>
          [
            key,
            <section>
              {this.props.children.map((child, index) =>
                React.cloneElement(child, {
                  key: `${child.props.name}-${index}`,
                  value: value.get(child.props.name),
                  saveValue: this.handleUpdateForm.bind(this, key, child.props.name, value.get('id')),
                })
              )}
              <IconButton
                key={`${this.props.name}-navclose-${key}`}
                onTouchTap={this.removeItem.bind(this, key)}
              >
                <NavigationClose />
              </IconButton>
            </section>,
          ]
        ).toList()}
        <CardActions
          style={{ textAlign: 'right' }}
        >
          <FlatButton
            onTouchTap={this.addAnotherItem}
            key={`${this.props.name}-contentadd`}
            label="Add"
          />
        </CardActions>
      </Card>
    );
  }
}

export default EditableCollection;



/** WEBPACK FOOTER **
 ** ./components/forms/EditableCollection.js
 **/